import { BookIcon, GoalIcon, NotepadText } from "lucide-react";
import React from "react";
import { FaNotesMedical } from "react-icons/fa";
import { GrDocumentNotes } from "react-icons/gr";

const JourneySection = () => {
    return (
        <section className="px-6 py-16 bg-white text-gray-800">
            <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
                {/* Left Section */}
                <div>
                    <p className="text-sm text-[#0097b2] uppercase tracking-widest mb-2">
                        Your Pathway to Success
                    </p>
                    <h2 className="md:text-4xl text-3xl font-semibold leading-tight mb-8">
                        Foundation to Selection <br /> With SSS Achievers
                    </h2>

                    {/* Features List */}
                    <div className="space-y-6">
                        {[
                            {
                                icon: <BookIcon/>,
                                title: "Strong Academic Foundation",
                                color: "bg-indigo-600",
                                description:
                                    "We build deep subject understanding from basics to advanced, tailored for school and competitive exams.",
                            },
                            {
                                icon:<NotepadText/>,
                                title: "Regular Tests & Evaluation",
                                color: "bg-yellow-400",
                                description:
                                    "Offline unit tests and performance tracking to prepare students for real exam conditions.",
                            },
                            {
                                icon: <GoalIcon/>,
                                title: "Focused Competitive Preparation",
                                color: "bg-green-600",
                                description:
                                    "Get guided training for government exams with expert faculty and exam-oriented study plans.",
                            },
                        ].map((item, idx) => (
                            <div key={idx} className="flex items-start space-x-4">
                            
                                <div className="mr-4 bg-[#0097b2]/10 p-3 rounded-full flex items-center justify-center">
        
                                    <p className="h-6 w-6 text-[#0097b2]"> {item.icon}</p>
                                </div>
                                <div>
                                    <h4 className="text-lg font-semibold mb-1">{item.title}</h4>
                                    <p className="text-gray-600 text-sm leading-relaxed">
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Section */}
                <div className="grid grid-cols-2 grid-rows-2 gap-4 h-full">
                    <div className="bg-[#0097b2] text-white p-6 flex flex-col justify-center rounded-md">
                        <h4 className="text-xl font-semibold mb-2">You Enroll</h4>
                        <p className="text-sm leading-relaxed">
                            Begin your journey with SSS Achievers – where every student gets the attention and support they deserve.
                        </p>
                    </div>

                    <div className="row-span-2 rounded-md overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1571260899304-425eee4c7efc"
                            alt="Student learning"
                            className="object-cover h-full w-full"
                        />
                    </div>

                    <div className="bg-yellow-400 text-gray-900 p-6 flex flex-col justify-center rounded-md">
                        <h4 className="text-xl font-semibold mb-2">We Train</h4>
                        <p className="text-sm leading-relaxed">
                            Our experienced faculty mentors you step-by-step – covering concepts, doubts, strategy, and confidence-building.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JourneySection;
